import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Phone, Facebook, Instagram } from 'lucide-react';
import { MobileNav } from './MobileNav';
const NAV_LINKS = [{
  name: 'Home',
  path: '/'
}, {
  name: 'About',
  path: '/about'
}, {
  name: 'Portfolio',
  path: '/portfolio'
}, {
  name: 'Services',
  path: '/services'
}, {
  name: 'Testimonials',
  path: '/testimonials'
}, {
  name: 'Store Info',
  path: '/store-info'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      {/* Eyebrow Bar - Above Header */}
      <div className="bg-cream-100 border-b border-taupe-200 py-2 px-4" data-id="element-70">
        <div className="max-w-7xl mx-auto text-center" data-id="element-71">
          <p className="text-xs md:text-sm text-charcoal-900/70 tracking-wide" data-id="element-72">
            Interior Design • Home Décor • Staging — Howell, Michigan + Brighton
            Area
          </p>
        </div>
      </div>

      {/* Main Header */}
      <header className={`sticky top-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-cream-100/95 backdrop-blur-md shadow-soft py-2' : 'bg-cream-100 py-3'}`} data-id="element-73">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
          <div className="flex items-center justify-between gap-4" data-id="element-75">
            {/* Logo */}
            <Link to="/" className="relative z-50 flex-shrink-0" data-id="element-76">
              <img src="https://cdn.magicpatterns.com/uploads/cPGepR4tzfa8FoK3BVJiwu/dark-logo2.png" alt="Down Home Interiors" className="h-14 md:h-16 w-auto object-contain" data-id="element-77" />
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center space-x-8" data-id="element-78">
              {NAV_LINKS.map(link => <Link key={link.path} to={link.path} className={`text-sm tracking-wide uppercase font-medium transition-colors hover:text-sage-500 ${location.pathname === link.path ? 'text-sage-500' : 'text-charcoal-900'}`} data-id="element-79">
                  {link.name}
                </Link>)}
            </nav>

            {/* Contact Info & Social - Desktop Only - Stacked */}
            <div className="hidden lg:flex flex-col items-end gap-2 flex-shrink-0" data-id="element-80">
              <a href="tel:5175455955" className="flex items-center gap-2 text-sm text-charcoal-900 hover:text-sage-500 transition-colors whitespace-nowrap" data-id="element-81">
                <Phone size={16} data-id="element-82" />
                <span data-id="element-83">(517) 545-5955</span>
              </a>
              <div className="flex items-center gap-3" data-id="element-84">
                <a href="https://www.facebook.com/DownTowneApparel/" target="_blank" rel="noopener noreferrer" className="text-charcoal-900 hover:text-sage-500 transition-colors" aria-label="Facebook" data-id="element-85">
                  <Facebook size={18} data-id="element-86" />
                </a>
                <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" className="text-charcoal-900 hover:text-sage-500 transition-colors" aria-label="Instagram" data-id="element-87">
                  <Instagram size={18} data-id="element-88" />
                </a>
              </div>
            </div>

            {/* Mobile Menu Trigger */}
            <button className="lg:hidden p-2 text-charcoal-900 hover:text-sage-500 transition-colors" onClick={() => setIsMobileOpen(true)} aria-label="Open menu" data-id="element-89">
              <Menu size={28} data-id="element-90" />
            </button>
          </div>
        </div>
      </header>

      <MobileNav isOpen={isMobileOpen} onClose={() => setIsMobileOpen(false)} links={NAV_LINKS} data-id="element-91" />
    </>;
}